import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import {
  CFIcon,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
  PrimaryModal,
} from 'components'
import { Locations } from 'pages'
import { dispatch } from 'store'

export default () => {
  const history = useHistory()
  const isMobile = useMediaQuery({ maxWidth: 767 })

  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (!dispatch.restaurant.getSelectedLocationId()) {
      if (isMobile) {
        history.push('/locations')
      } else {
        setShowModal(true)
      }
    }
  }, [history, isMobile])

  const navigateLocation = () => {
    if (isMobile) {
      history.push('/locations')
    } else {
      setShowModal(true)
    }
  }

  return (
    <CFView>
      <MobileScreen>
        <CFView h="45px" w="100%" center onClick={navigateLocation}>
          <CFIcon icon="map-marker-alt" color="#F26824" fontSize={22} />
          <CFView color="#F26824" h3 bold mh="10px" mb="2px">
            <CFSelect selector={dispatch.restaurant.getLocationName} />
          </CFView>
          <CFIcon icon="angle-down" color="#F26824" fontSize={30} />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFSelect selector={dispatch.restaurant.getLocationName}>
          <CFView
            center
            br="20px"
            bc="#F26824"
            bw="2px"
            pv="5px"
            ph="15px"
            pointer
            onClick={navigateLocation}
            hover
            zIndex={99}
          >
            <CFView color="#F26824" bold mr="10px" mb="2px">
              <CFSelect selector={dispatch.restaurant.getLocationName} />
            </CFView>
            <CFIcon icon="angle-down" color="#F26824" fontSize={28} />
          </CFView>
        </CFSelect>
      </DefaultScreen>
      <PrimaryModal title="Locations" isOpen={showModal}>
        <Locations onRequestClose={() => setShowModal(false)} />
      </PrimaryModal>
    </CFView>
  )
}
